/**
 * 業務マップ（F1）のルート定義。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 業務マップのルートを定義する。
 * @graph-connects none
 */
import { createRoute } from '@tanstack/react-router';
import { BusinessMapRoutePage } from '../receivers/business-map.js';
import { parsePjSearch } from '../pj-search.js';
import { BUSINESS_MAP_ROUTE } from '../route-paths.js';
import { rootRoute } from './root.js';

/**
 * ①業務マップ（作り直し）。旧の業務ツリー（`/epics`）と業務の一覧（`/businesses`）を畳んだ先。
 *
 * 検索条件で案件を受ける。畳んだ旧の 2 本がどちらも `?pj=` を読んでいたので、受けないと
 * 案件を選んだまま旧の入口を開いていた利用者が、畳んだ先で黙ってマスターへ落ちる。
 * 受け取った案件をどう使うかは受け口（`BusinessMapRoutePage`）が持つ。
 * @graph-connects none
 */
export const businessMapRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: BUSINESS_MAP_ROUTE,
  component: BusinessMapRoutePage,
  validateSearch: parsePjSearch,
});

/** 業務マップのルート。ルート木（`app.tsx`）はこれを並べる。 @graph-connects none */
export const businessMapRoutes = [businessMapRoute] as const;
